import React from "react";

import Button from "components/Form/Button";
import LearningPathTimeline from "components/LearningPathTimeline";
import { FormSpacer } from "ui/styled";
import useController from "./controller";
import LearningPathDetailsSkeleton from "./Skeleton";
import {
  BackButton,
  EmptyState,
  HeroActions,
  HeroContent,
  HeroEyebrow,
  HeroShell,
  HeroStats,
  PageRoot,
  ProgressBar,
  ProgressFill,
  ProgressMeta,
  ProgressStack,
  StatItem,
  StatLabel,
  StatValue,
  Subtitle,
  Title,
} from "./styled";

export default function LearningPathDetails({ portal }) {
  const {
    completeItem,
    continueTrail,
    goBack,
    loading,
    loadingItemId,
    openItem,
    starting,
    trail,
  } = useController(portal);
  const percent = Number(trail?.completionPercent || 0);
  const clampedPercent = Math.max(0, Math.min(percent, 100));
  const itemCount = trail?.itemCount || trail?.items?.length || 0;
  const courseCount = trail?.courseCount || trail?.courses?.length || 0;
  const stepCount = trail?.stepCount || trail?.steps?.length || 0;
  const requiredCount = trail?.requiredStepCount || stepCount || 0;
  const statusLabel = trail?.status === "completed"
    ? "Completed"
    : trail?.status === "in_progress"
      ? "In progress"
      : "Not started";

  return (
    <>
      <FormSpacer extraLarge />
      {loading ? (
        <LearningPathDetailsSkeleton />
      ) : !trail ? (
        <PageRoot>
          <EmptyState>Learning path not found.</EmptyState>
        </PageRoot>
      ) : (
        <PageRoot>
          <BackButton onClick={goBack}>Back to paths</BackButton>
          <HeroShell image={trail?.imageUrl || null}>
            <HeroContent>
              <HeroEyebrow>Learning path</HeroEyebrow>
              <Title>{trail.title}</Title>
              {trail.description ? <Subtitle>{trail.description}</Subtitle> : null}
              <HeroActions>
                <Button color="blue" width="fit-content" loading={starting} onClick={continueTrail}>
                  {trail?.status === "completed" ? "View path" : trail?.progress?.startedAt ? "Continue path" : "Start path"}
                </Button>
                <ProgressStack>
                  <ProgressMeta>
                    <span>{clampedPercent}% complete</span>
                    <span>{trail.completedStepCount || 0}/{requiredCount} required steps</span>
                  </ProgressMeta>
                  <ProgressBar>
                    <ProgressFill style={{ width: `${clampedPercent}%` }} />
                  </ProgressBar>
                </ProgressStack>
              </HeroActions>
            </HeroContent>

            <HeroStats>
              <StatItem>
                <StatValue>{stepCount}</StatValue>
                <StatLabel>Steps</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{courseCount}</StatValue>
                <StatLabel>Courses</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{itemCount}</StatValue>
                <StatLabel>Items</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{statusLabel}</StatValue>
                <StatLabel>Status</StatLabel>
              </StatItem>
            </HeroStats>
          </HeroShell>

          <LearningPathTimeline
            steps={trail?.steps || []}
            loadingItemId={loadingItemId}
            onOpenItem={openItem}
            onCompleteItem={completeItem}
          />
        </PageRoot>
      )}
    </>
  );
}
